<h2 class="default-dialog-header" mat-dialog-title class="default-dialog-header m-b-1">
	<span *ngIf="!data.isEditProject">Create Project</span>
	<span *ngIf="!data.isEditProject && data.type" fxFlex fxLayoutAlign="left end" class="fs-13 ml-6">
		- {{ formatType(data.type) }}
	</span>
	<span *ngIf="data.isEditProject" fxFlex>Update Project Details</span>
	<span fxFlex fxLayoutAlign="end center">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color" style="cursor: pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>

<form (keydown.enter)="$event.preventDefault()" [formGroup]="projectDetails" *ngIf="projectDetails">
	<mat-dialog-content class="p-t-0 p-b-0 default-dialog-content">
		<div
			*ngIf="data.addProject && isSearchTruckFormDataAvailable()"
			style="background-color: #e2e2e2"
		>
			<div fxLayout="row" fxLayoutAlign="center center" style="padding: 0.5rem">
				<div class="textWithIcon" fxFlex>
					<mat-icon class="primary-light-color m-r-1">place</mat-icon>
					<b> Origin</b>
				</div>
				<div fxFlex>
					{{ data.searchTruckForm.origin.city + ', ' + data.searchTruckForm.origin.state }}
				</div>

				<div class="textWithIcon" fxFlex>
					<mat-icon class="primary-light-color m-r-1">place</mat-icon>
					<b> Destination</b>
				</div>
				<div fxFlex>
					{{ data.searchTruckForm.destination.city + ', ' + data.searchTruckForm.destination.state}}
				</div>

				<div class="textWithIcon" fxFlex>
					<mat-icon class="primary-light-color m-r-1">local_shipping</mat-icon>
					<b> Trailer Type</b>
				</div>
				<div fxFlex>{{ data.searchTruckForm.trailerType}}</div>
			</div>
		</div>

		<app-default-progress-bar *ngIf="!isFormInitialized"></app-default-progress-bar>

		<div *ngIf="isFormInitialized" class="p-1">
			<div
				*ngIf="(data.addProject && !isSearchTruckFormDataAvailable()) ||
				( (data.isEditProject || data.isDuplicateProject) && !utilService.isNullOrUndefined(data.projectDTO))"
			>
				<app-search-truck-bar
					customFormFieldClass="remove_form_field_margin"
					placeholderRequiredClass="placeholder-required"
					[allowStateSelection]="false"
					[initialDestination]="destination"
					[initialOrigin]="origin"
					[isEditProject]="data.isEditProject || data.isDuplicateProject"
					[isFormDataAvailable]="data.isEditProject || data.isDuplicateProject"
					[multipleTrailerTypes]="true"
					[projectDTO]="data.projectDTO"
					[showPickupDate]="false"
					[useSearch]="false"
					[isOriginRequired]="projectDetails.controls['originCity'].invalid"
					[isDestinationRequired]="projectDetails.controls['destCity'].invalid"
					[isTrailerTypesRequired]="projectDetails.controls['equipmentType'].invalid"
					[trailerType]="trailerType"
					[useTrailerTypesDefault]="false"
					(syncFormData)="syncSearchData($event)"
				></app-search-truck-bar>
			</div>
			<div *ngIf="laneIsRequired()" class="fs-13 m-b-1 message-margin">
				* If origin, destination, or trailer type are selected, then all must be provided.
			</div>
			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem" class="m-t-0-5">
				<div fxFlex fxLayoutAlign="start center">
					<app-customer-popover
						fxFlex
						customFormFieldClass="remove_form_field_margin"
						[showCloseIcon]="true"
						[customerSelected]="projectDetails.get('customerDTO').value"
						(setCustomer)="setCustomer($event)"
					></app-customer-popover>
				</div>
				<div fxFlex fxLayoutAlign="start center">
					<mat-form-field fxFlex="100" class="remove_form_field_margin" placeholder="Revenue Code">
						<input formControlName="revenueCode" matInput type="text" (change)="setProjectName()" />
					</mat-form-field>
				</div>
			</div>

			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
				<div fxFlex>
					<mat-form-field fxFlex="100" class="remove_form_field_margin">
						<mat-label>Duration</mat-label>
						<mat-select formControlName="loadVolumeDuration">
							<mat-option *ngFor="let duration of loadVolumeDuration" [value]="duration">
								{{duration}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div fxFlex>
					<mat-form-field fxFlex="100" class="remove_form_field_margin">
						<input
							autocomplete="off"
							formControlName="loadVolume"
							mask="separator"
							thousandSeparator=","
							matInput
							placeholder="Load Count"
						/>
					</mat-form-field>
				</div>

				<div fxFlex>
					<h4
						(click)="setSpecifyDays()"
						*ngIf="!specifyDays"
						class="primary-text font-weight-normal cursor-pointer"
						fxLayoutAlign="center center"
					>
						Specify Days
						<mat-icon class="primary-light-color m-r-1 mt-2">expand_more</mat-icon>
					</h4>
					<h4
						(click)="setSpecifyDays()"
						*ngIf="specifyDays"
						class="primary-text font-weight-normal cursor-pointer"
						fxLayoutAlign="center start"
					>
						Days Run
						<mat-icon class="primary-light-color m-r-1 mt-2">expand_less</mat-icon>
					</h4>
				</div>
			</div>

			<div *ngIf="specifyDays">
				<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem">
					<mat-checkbox [color]=" 'primary' " [labelPosition]=" 'after' " formControlName="monday">
						Monday
					</mat-checkbox>
					<mat-checkbox [color]=" 'primary' " [labelPosition]=" 'after' " formControlName="tuesday">
						Tuesday
					</mat-checkbox>
					<mat-checkbox
						[color]=" 'primary' "
						[labelPosition]=" 'after' "
						formControlName="wednesday"
					>
						Wednesday
					</mat-checkbox>
					<mat-checkbox
						[color]=" 'primary' "
						[labelPosition]=" 'after' "
						formControlName="thursday"
					>
						Thursday
					</mat-checkbox>
					<mat-checkbox [color]=" 'primary' " [labelPosition]=" 'after' " formControlName="friday">
						Friday
					</mat-checkbox>
					<mat-checkbox
						[color]=" 'primary' "
						[labelPosition]=" 'after' "
						formControlName="saturday"
					>
						Saturday
					</mat-checkbox>
					<mat-checkbox [color]=" 'primary' " [labelPosition]=" 'after' " formControlName="sunday">
						Sunday
					</mat-checkbox>
				</div>
			</div>

			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
				<div fxFlex>
					<mat-form-field fxFlex="100" class="remove_form_field_margin">
						<input
							(click)="picker2.open()"
							[formControl]="dueDate"
							[matDatepicker]="picker2"
							[min]="minimumDueDate"
							matInput
							placeholder="Due Date"
						/>
						<mat-datepicker-toggle [for]="picker2" matSuffix tabIndex="-1"></mat-datepicker-toggle>
						<mat-datepicker #picker2></mat-datepicker>
					</mat-form-field>
				</div>

				<div fxFlex>
					<mat-form-field class="remove_form_field_margin" fxFlex>
						<mat-label>Stage</mat-label>
						<mat-select formControlName="stageId">
							<mat-option *ngFor="let stage of PROJECT_STAGES" [value]="stage.type">
								{{stage.label}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div fxFlex>
					<mat-form-field fxFlex="100" class="remove_form_field_margin">
						<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
							>attach_money</mat-icon
						>
						<input
							formControlName="value"
							mask="separator"
							thousandSeparator=","
							matInput
							placeholder="Value"
						/>
					</mat-form-field>
				</div>
			</div>

			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem" class="m-t-0-5">
				<div fxFlex>
					<mat-form-field fxFlex="100" class="remove_form_field_margin">
						<mat-icon class="primary-light-color vertical-align-bottom" matPrefix>
							attach_money
						</mat-icon>
						<input
							(input)="maxBuyChanged()"
							autocomplete="off"
							formControlName="maxBuy"
							mask="separator"
							thousandSeparator=","
							matInput
							placeholder="Max Buy"
						/>
					</mat-form-field>
				</div>
				<div fxFlex="30"></div>
				<div fxFlex="30"></div>
			</div>

			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem" class="m-t-0-5">
				<div fxFlex>
					<mat-form-field fxFlex="100" class="row-height remove_form_field_margin">
						<textarea
							placeholder="Commodity"
							matInput
							maxlength="256"
							formControlName="commodity"
							cdkTextareaAutosize
							cdkAutosizeMinRows="1"
						>
						</textarea>
					</mat-form-field>
				</div>

				<div fxFlex fxLayoutAlign="start center">
					<mat-form-field fxFlex="100" class="remove_form_field_margin">
						<input
							formControlName="weight"
							mask="separator"
							thousandSeparator=","
							matInput
							placeholder="Total Weight (lbs)"
							type="text"
						/>
					</mat-form-field>
				</div>
			</div>

			<div fxLayout="row" fxLayoutGap="1rem" class="m-t-0-5">
				<div *ngIf="IS_TEAMS_CAPACITY_ENABLED" fxFlex="30" fxLayoutAlign="start center">
					<mat-checkbox color="primary" formControlName="requireTeams">
						Require Teams
					</mat-checkbox>
				</div>
				<div
					*ngIf="accountSettings.PROJECT_GROUPS_ENABLED && data.type === PROJECT_TYPES.WATERFALL.value"
					fxFlex="30"
					fxLayoutAlign="start center"
				>
					<mat-checkbox
						name="invite-ungrouped-carriers"
						color="primary"
						formControlName="inviteUngroupedCarriers"
						(change)="inviteUngroupedCarriersUpdated($event);$event.stopPropagation();"
					>
						Send to Network Carriers in &nbsp;
						<input
							floatLabel="never"
							formControlName="ungroupedCarriersDelay"
							matInput
							fxFlex="12"
							type="text"
							class="ungrouped-carriers-delay-input"
						/>
						&nbsp; min
					</mat-checkbox>
				</div>
				<div fxFlex fxLayout="row" fxLayoutAlign="end center">
					<h4
						(click)="notesExpanded = !notesExpanded"
						class="primary-text font-weight-normal cursor-pointer m-0"
						fxLayoutAlign="center start"
					>
						Add Notes
						<mat-icon *ngIf="!notesExpanded" class="primary-light-color m-l-1 mt-2"
							>expand_more</mat-icon
						>
						<mat-icon *ngIf="notesExpanded" class="primary-light-color m-l-1 mt-2"
							>expand_less</mat-icon
						>
					</h4>
				</div>
			</div>

			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem" class="m-t-0-5">
				<div fxFlex="50" fxLayoutAlign="start center">
					<mat-form-field fxFlex="100" class="remove_form_field_margin">
						<mat-label class="placeholder-required">Project Name</mat-label>
						<input formControlName="name" matInput required type="text" />
					</mat-form-field>
				</div>
				<div fxFlex></div>
			</div>

			<div
				*ngIf="isWaterfallOrDedicatedLaneProject && accountSettings.ENABLE_OUT_OF_NETWORK_CARRIERS"
				fxLayout="row"
				fxLayoutAlign="center center"
				fxLayoutGap="1rem"
				class="m-t-0-5"
			>
				<div fxFlex="50" fxLayoutAlign="start center">
					<mat-checkbox
						name="invite-ungrouped-carriers"
						color="primary"
						formControlName="sendToOutOfNetworkCarriers"
						(change)="onOutOfNetworkUpdate($event);"
					>
						Send Out of Network Offers in &nbsp;
						<input
							floatLabel="never"
							formControlName="sendToOutOfNetworkCarriersDelay"
							matInput
							fxFlex="12"
							type="number"
							class="ungrouped-carriers-delay-input"
						/>
						&nbsp; min
					</mat-checkbox>
				</div>
				<div fxFlex></div>
			</div>

			<div *ngIf="notesExpanded">
				<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
					<div fxFlex>
						<mat-form-field fxFlex="100" class="remove_form_field_margin">
							<textarea
								formControlName="packaging"
								matAutosizeMinRows="1"
								matInput
								matTextareaAutosize
								maxlength="256"
								placeholder="Packaging"
							>
							</textarea>
						</mat-form-field>
					</div>
				</div>
				<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
					<div fxFlex>
						<mat-form-field fxFlex="100" class="remove_form_field_margin">
							<textarea
								formControlName="trailerRequirements"
								matAutosizeMinRows="1"
								matInput
								matTextareaAutosize
								maxlength="256"
								placeholder="Trailer Requirements"
							>
							</textarea>
						</mat-form-field>
					</div>
				</div>
				<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
					<div fxFlex>
						<mat-form-field fxFlex="100" class="remove_form_field_margin">
							<textarea
								formControlName="shipperNotes"
								matInput
								maxlength="1024"
								placeholder="Shipper Notes"
							>
							</textarea>
						</mat-form-field>
					</div>
				</div>
				<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
					<div fxFlex>
						<mat-form-field fxFlex="100" class="remove_form_field_margin">
							<textarea
								formControlName="receiverNotes"
								matInput
								maxlength="1024"
								placeholder="Receiver Notes"
							>
							</textarea>
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>
	</mat-dialog-content>

	<mat-divider></mat-divider>

	<mat-dialog-actions class="default-dialog-action dialog_action_container" fxLayoutGap="1rem">
		<div
			*ngIf="planProductService.IS_ADMIN_OR_OWNER && data.addProject"
			fxFlex="40"
			fxLayoutAlign="center end"
		>
			<app-user-popover
				customFormFieldClass="remove_form_field_margin"
				[isEnabled]="true"
				[showAssignMeOnRight]="true"
				[singleselect]="true"
				[usersList]="usersList"
				(userChanged)="setAssignee($event)"
			>
			</app-user-popover>
		</div>

		<div fxFlex fxLayoutAlign="end end" fxLayoutGap="1rem">
			<span (click)="closeDialog(null)" class="link font-size-14" fxLayoutAlign="end end">
				Cancel
			</span>
			<button
				(click)=" data.addProject || data.isDuplicateProject ? addProject() : data.isEditProject ? updateProject() : '' "
				*ngIf="!isRequestInProgress"
				[disabled]="projectDetails.invalid"
				color="primary"
				mat-raised-button
			>
				{{data.addProject || data.isDuplicateProject ? 'Create' : data.isEditProject ? 'Update
				Project' : ''}}
			</button>
			<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
		</div>
	</mat-dialog-actions>
</form>
